export const blockIconsMapsLunchDining = (
	<span className='material-symbols-outlined'>lunch_dining</span>
);
